import { Logger, LoggerService } from '@Shared/logger';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';
import { AppleService } from '@Modules/apple_module';

export class PreAppleLoginStep implements PipelineStep {
  private Logger: Logger = LoggerService.createLogger('PreAppleLoginStep');

  constructor() {
    this.Logger.trace('****  CTOR ****');
  }

  async execute(context: PipelineContext): Promise<PipelineStep | null> {
    this.Logger.trace('Executing....', context);
    await AppleService.Instance.initiatePreAppleLogin();
    return null;
  }
}
